import './moreSettingPanel.scss';
import { isMobile } from '@umu/umu-ua';
import { If } from 'common/src/components';
import React, { useEffect, useState } from 'react';
import { LabelAndValueOptions } from '../interface';
import SpeedSetting from '../speedSetting/speedSetting';
import { MoreSettingCurrentOperation } from '../dataflow';
import AISubtitleSetting from '../aiSubtitleSetting/aiSubtitleSetting';
import AiSubtitleTranslateSettingPanel from '../aiSubtitleTranslateSettingPanel/aiSubtitleTranslateSettingPanel';

export type MoreSettingPanelProps = {
    visible: boolean;
    uControlBar: any;
    emitCustomEvent: any;
    speed: LabelAndValueOptions;
    setting: {[key: string]: any};
    aiSubtitleSwitchChecked?: boolean;
    setIsShowDrawerCancel?: (value: any) => void;
    setSpeed: (value: LabelAndValueOptions)=> void;
    setSetting: (value: {[key: string]: any})=> void;
    setAiSubtitleSwitchChecked?: (value: boolean)=> void;
};

function MoreSettingPanel(props: MoreSettingPanelProps) {
    const { uControlBar, visible: visibleProp, emitCustomEvent,setIsShowDrawerCancel,setting,setSetting,speed,setSpeed,aiSubtitleSwitchChecked,setAiSubtitleSwitchChecked } = props;
    const [currentOperation, setCurrentOption] = useState<MoreSettingCurrentOperation>(MoreSettingCurrentOperation.all);

    const renderSplitLine = ()=>{
        return <div className="line"></div>
    }

    const renderSpeedSetting = ()=>{
        return <SpeedSetting speed={speed} setSpeed={setSpeed} uControlBar={uControlBar} emitCustomEvent={emitCustomEvent} />
    }

    const renderSubtitleSetting = ()=>{
        return <AISubtitleSetting
            uControlBar={uControlBar}
            isInMoreSetting={true}
            emitCustomEvent={emitCustomEvent}
            setMoreCurrentOption={setCurrentOption}
            aiSubtitleSwitchChecked={aiSubtitleSwitchChecked}
            setAiSubtitleSwitchChecked={setAiSubtitleSwitchChecked}
        />
    }

    const renderMenuList = ()=>{
        const isHiddenSetupSetting = (uControlBar?.config?.subtitleConfig?.translateSettingShow?.isHiddenSubtitleSetting ?? false);
        const isShowSpeedSetting = uControlBar?.config?.hasSpeed;
        const isShowSubtitleSetting = uControlBar?.config?.hasSubtitle && !isHiddenSetupSetting;
        
        let result:any[] = [];

        if(isMobile){
            isShowSubtitleSetting && result.push(renderSubtitleSetting());
            if(isShowSpeedSetting){
                isShowSubtitleSetting ? result.push(...[renderSplitLine(),renderSpeedSetting()]) : result.push(renderSpeedSetting())
            }
           
        }else{
            isShowSpeedSetting && result.push(renderSpeedSetting());
            if(isShowSubtitleSetting){
                isShowSpeedSetting ? result.push(...[renderSplitLine(),renderSubtitleSetting()]) : result.push(renderSubtitleSetting())
            }
        }

        return <>{
            result.map((item,index)=> <div key={index}>{ item }</div>)
        }</>
    }

    useEffect(() => {
        if (currentOperation !== MoreSettingCurrentOperation.all) {
            setIsShowDrawerCancel?.(false);
            return;
        }
        setIsShowDrawerCancel?.(true);
    }, [currentOperation]);

    

    return (
        <div className={`u-player-more-setting-panel ${isMobile ? 'm' : 'pc'}`}>
            {/* 所有设置面板 */}
            <If condition={currentOperation === MoreSettingCurrentOperation.all}>
            {
                renderMenuList()
            }
            </If>
            {/* 字幕翻译设置面板 */}
            <If condition={currentOperation === MoreSettingCurrentOperation.aiSubTitleTranslate}>
                <AiSubtitleTranslateSettingPanel
                    setting={setting}
                    visible={visibleProp}
                    isInMoreSetting={true}
                    setSetting={setSetting}
                    uControlBar={uControlBar}
                    emitCustomEvent={emitCustomEvent}
                    setMoreCurrentOption={setCurrentOption}
                />
            </If>
        </div>
    );
}

export default MoreSettingPanel;
